import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'

export const getSelectedColor = (selectedOptions: ProductVariantOption[]) =>
  selectedOptions.filter(o => o.name == ProductOptionName.Color)[0]?.value
